import { render } from "./infoClassifications.vue?vue&type=template&id=75a1eef2&ts=true"
import script from "./infoClassifications.vue?vue&type=script&lang=ts"
export * from "./infoClassifications.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__